import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import dashboardIcon from '@iconify/icons-mdi/view-dashboard-outline';
import listIcon from '@iconify/icons-mdi/view-list-outline';
import reportIcon from '@iconify/icons-mdi/chart-areaspline';

export interface MenuItem {
  id: number;
  name: string;
  icon: string;
  selectable: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FieldsInterventionsNavigationService {

  current: MenuItem;
  backgroundMenu: MenuItem;

  menu = [{
    id: 1,
    name: 'Tableau de bord',
    icon: 'ld-dashboard',
    selectable: true,
  }, {
    id: 2,
    name: 'Liste',
    icon: 'ld-list',
    selectable: true,
  }, {
    id: 3,
    name: 'Rapport',
    icon: 'ld-chart-line',
    selectable: true,
  }, /*{
    id: 4,
    name: 'Paramètres',
    icon: 'preferences',
    selectable: false,
  }*/];

  private _navigationSubject = new Subject<{ current: MenuItem, background: MenuItem }>();
  navigate$ = this._navigationSubject.asObservable();

  constructor() {
    this.current = this.menu[1];
    this.backgroundMenu = this.menu[1];
  }

  navigateTo(menu: MenuItem) {
    this.backgroundMenu = !menu.selectable ? this.current : menu;
    this.current = menu;
    this._navigationSubject.next({current: menu, background: this.backgroundMenu});
  }

  navigateById(id: number) {
    const menu = this.menu.find((m) => m.id === id);
    if (menu) {
      this.navigateTo(menu);
    }
  }

}
